import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent, Box, Stack, Text } from '@nike/podium';
import { extractFieldValue, getFieldLabel, hasFieldsWithValues } from '~/utils/entityDetailUtils';
export function DetailRow({ label, value }) {
    if (!value)
        return null;
    return (_jsxs(Stack, { horizontal: true, gap: "m", className: "w-full", children: [_jsx(Box, { className: "w-1/2", children: _jsx(Text, { font: "body-2", className: "pds-color-text-secondary", children: label }) }), _jsx(Box, { className: "w-1/2 flex-1", children: _jsx(Text, { font: "body-2", children: value }) })] }));
}
export function KeyAttribute({ label, value }) {
    return (_jsxs(Stack, { gap: "xs", children: [_jsx(Text, { font: "body-2", className: "pds-color-text-secondary", children: _jsx(_Fragment, { children: label }) }), _jsx(Text, { font: "title-4", children: value || '—' })] }));
}
export function StackedDetail({ label, value }) {
    if (!value)
        return null;
    return (_jsxs(Stack, { gap: "xs", children: [_jsx(Text, { font: "body-2", className: "pds-color-text-secondary", children: label }), _jsx(Text, { font: "body-2", children: value })] }));
}
export function HighlightedSection({ items }) {
    return (_jsx(Box, { className: "border-b pds-color-border-tertiary py-4", children: _jsx(Stack, { horizontal: true, gap: "s", className: "w-full", children: items.map((item) => (_jsx(Box, { className: "flex-1", children: _jsx(KeyAttribute, { label: item.label, value: item.value }) }, item.label))) }) }));
}
export function DetailSection({ value, title, children }) {
    return (_jsxs(AccordionItem, { value: value, children: [_jsx(AccordionTrigger, { children: title }), _jsx(AccordionContent, { children: _jsx(Stack, { gap: "m", children: children }) })] }));
}
export function DetailAccordion({ defaultOpen, children }) {
    return (_jsx(Accordion, { type: "multiple", defaultValue: defaultOpen, className: "w-full", children: children }));
}
export function FieldRenderer({ entity, field, displayType = 'row', customLabels = {} }) {
    const value = extractFieldValue(entity, field);
    const label = getFieldLabel(field, customLabels);
    if (!value)
        return null;
    switch (displayType) {
        case 'key-attribute':
            return _jsx(KeyAttribute, { label: label, value: value });
        case 'stacked':
            return _jsx(StackedDetail, { label: label, value: value });
        default:
            return _jsx(DetailRow, { label: label, value: value });
    }
}
export function CategorySection({ entity, section, customLabels = {} }) {
    if (!hasFieldsWithValues(entity, section)) {
        return null;
    }
    return (_jsx(DetailSection, { value: section.id, title: section.title, children: section.fields.map((field) => (_jsx(FieldRenderer, { entity: entity, field: field, displayType: section.displayType, customLabels: customLabels }, field))) }));
}
